import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { responseAmbientes } from '../../models/login/ambientes.model'

enum ServicesAmbientes {
  ambiente = "environments"
}

@Injectable({
  providedIn: 'root'
})
export class AmbientesService {

  // url = `${environment.urlSesio}/${ServicesAmbientes.ambiente}`;  

  constructor( private http: HttpClient ) { }

  // getAmbientes(): Observable<responseAmbientes> {
  //   return this.http.get<responseAmbientes>(this.url).pipe( map( (resp:responseAmbientes) => { return resp } ));
  // }
}
